import { AbstractEntityMapper } from '@pf/shared-services';
import {
    ExceptionCreate,
    ExceptionDto,
    ExceptionRead,
    ExceptionSearchParams,
} from '../../entities/exception.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { ExceptionMetadataMap } from './exception.mapping-profile';

@Injectable()
export class ExceptionMapper extends AbstractEntityMapper<
    ExceptionRead,
    ExceptionCreate,
    ExceptionDto,
    ExceptionSearchParams
> {
    constructor() {
        super(ExceptionDto, PlatformWmsMapper, ExceptionMetadataMap.symbols);
    }
}
